import { fromLonLat } from 'ol/proj'

export function moveMapView({ map, view, lat, lon, noZoom = false }: any) {
  const mapView = map.getView()
  const currentZoom = view.getZoom()

  const targetZoom = 18
  const nextZoom = Math.max(currentZoom, targetZoom)

  mapView.animate({
    center: fromLonLat([lon, lat]),
    zoom: noZoom ? currentZoom : nextZoom,
    duration: 800,
  })
}
